export default "__VITE_ASSET__BvsUTc8n__"